import { z } from "zod";
import type {
	Currency,
	PortfolioFilters,
	PortfolioSearchParams,
} from "../types/types";

export const CURRENCY_OPTIONS: Currency[] = ["SAR", "USD"];

export const DEFAULT_PORTFOLIO_FILTERS: PortfolioFilters = {
	currency: "SAR",
};

// The dashboard API takes no filters; currency is the one view setting left.
// Unknown keys (old demo links: asOf, product, compare…) are dropped.
const schema = z.object({
	currency: z.enum(["SAR", "USD"]).optional().catch(undefined),
});

/** `validateSearch` for the portfolio routes — a malformed URL degrades to defaults. */
export const validatePortfolioSearch = (
	search: Record<string, unknown>,
): PortfolioSearchParams => {
	const parsed = schema.parse(search);
	return parsed.currency ? { currency: parsed.currency } : {};
};

export const resolvePortfolioFilters = (
	search: PortfolioSearchParams,
): PortfolioFilters => ({ ...DEFAULT_PORTFOLIO_FILTERS, ...search });

/** Turns filters into search params, dropping values equal to the default. */
export const toPortfolioSearch = (
	filters: PortfolioFilters,
): PortfolioSearchParams =>
	filters.currency !== DEFAULT_PORTFOLIO_FILTERS.currency
		? { currency: filters.currency }
		: {};
